import React from "react"
import PropTypes from "prop-types"

const PageHeader = ({ overline, heading, text }) => {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <div className="text-center">
          {overline && (
            <span className="text-base font-semibold text-softGreen-700 leading-6">
              {overline}
            </span>
          )}

          <h1 className="normal text-darkBlue-900 max-w-4xl mx-auto">{heading}</h1>

          {text && <p className="max-w-xl mt-5 mx-auto body-text-lg">{text}</p>}
        </div>
      </div>
    </div>
  )
}

export default PageHeader

PageHeader.propTypes = {
  heading: PropTypes.string.isRequired,
}

PageHeader.defaultProps = {
  heading: "Page Title",
}
